import { Splide, SplideSlide } from '@splidejs/react-splide';
import BlogItem from './blog_item';

const BlogCarousel = ({ posts, perRow = 3 }) => (
  <div className="contentful__carousel contentful__container__blog-carousel p-0">
    <Splide
      options={{
        pagination: false,
        mediaQuery: 'min',
        breakpoints: { 768: { destroy: true } },
      }}
      hasTrack={false}
      className="splide fl fl-col-reverse ai-fe"
      role="group"
      aria-label="product image carousel">
      <div className="splide__track">
        <ul
          className={`splide__list contentful__blog-grid blog-grid--grid-${perRow}`}>
          {posts.map(post => (
            <SplideSlide
              className="splide__slide fl"
              key={post.url}
              data-testid="splide__slide--similarstock-item">
              <BlogItem {...post} />
            </SplideSlide>
          ))}
        </ul>
      </div>
    </Splide>
  </div>
);

export default BlogCarousel;
